import React, { memo, useMemo } from "react";
import useTranslation from "next-translate/useTranslation";
import { Text } from "@utils/helper";
import Link from "next/link";
import { Icon } from "@utils/helper";

const Footer = () => {
  const { t } = useTranslation("common-locale");

  const socials = useMemo(() => [
    { id: "sms", link: "mailto:info@investaseel.sa" },
    { id: "linkedin", link: "https://www.linkedin.com/company/aseel/" },
    { id: "instagram", link: "https://www.instagram.com/investaseel" },
    { id: "x", link: "https://x.com/investaseel" },
  ]);

  const menu = useMemo(() => [
    {
      title: t("footer.company"),
      list: [
        { title: t("footer.about_us"), link: "/about-us" },
        { title: t("footer.member_council"), link: "/directors" },
        {
          title: t("footer.sharia_committee"),
          link: "/sharia-committee",
        },
        { title: t("footer.faq"), link: "/faq" },
      ],
    },
    {
      title: t("footer.investment"),
      list: [
        {
          title: t("footer.real_estate"),
          link: "/#aseel_offers?fund=1",
        },
        { title: t("footer.financing"), link: "/#aseel_offers?fund=2" },
        {
          title: t("footer.private_equity"),
          link: "/#aseel_offers?fund=3",
        },
        { title: t("footer.equity"), link: "/#aseel_offers?fund=4" },
      ],
    },
    {
      title: t("footer.information"),
      list: [
        { title: t("footer.how_works"), link: "/#how_aseel_works" },
        { title: t("footer.aseel_numbers"), link: "/#statistics" },
        { title: t("footer.why_funds"), link: "/#why-funds" },
        {
          title: t("footer.submit_opportunity"),
          link: "/submit-opportunities",
        },
      ].filter(Boolean),
    },
  ]);

  const menuBottom = useMemo(() => [
    { title: t("footer.privacy_policy"), link: "/privacy-policy" },
    { title: t("footer.agreement"), link: "/opening-agreement" },
    {
      title: t("footer.conflict-policy"),
      link: "/conflict-policy",
    },
  ]);

  return (
    <>
      <div className="bg-[#011291]">
        <div className="base-container">
          <div className="flex justify-between flex-col md:flex-row gap-8 pt-[80px] pb-[72px]">
            <div className="w-full flex flex-col gap-[49px] md:max-w-[288px] justify-between">
              <div className="flex flex-col gap-[49px]">
                <div className="flex flex-col gap-[19px]">
                  <Link href="/" className="w-fit">
                    <Icon
                      id="LogoWhite"
                      width={153.3}
                      height={61.72}
                      viewBox="0 0 173 64"
                    />
                  </Link>
                  <Text
                    color="#FFFFFF"
                    fontType="Expo_bok"
                    weight="400"
                    className="leading-[30px]"
                  >
                    {t("footer.description")}
                  </Text>
                </div>
                <div className="flex w-[175px] justify-between py-0.5 items-center">
                  {socials.map((item, index) => (
                    <Link key={index} href={item.link} target="_blank">
                      <Icon id={item.id} width={20} height={20} />
                    </Link>
                  ))}
                </div>
              </div>
            </div>
            <div className="flex md:max-w-fit flex-wrap gap-[59px]">
              {menu.map((item, index) => (
                <div key={index} className="flex flex-col gap-8">
                  <Text
                    size="20px"
                    weight="400"
                    color="#FFFFFF"
                    fontType="Expo_sim"
                    className="leading-[30px]"
                  >
                    {item.title}
                  </Text>
                  <div key={index} className="flex flex-col gap-6">
                    {item.list.map((list, index) => (
                      <Link key={index} href={list.link}>
                        <Text
                          weight="400"
                          color="#F3F5F8"
                          fontType="Expo_bok"
                          className="leading-[21px] whitespace-nowrap"
                        >
                          {list.title}
                        </Text>
                      </Link>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="bg-[#011291]">
        <div className="w-full h-[1px] bg-gradient-to-tr from-[#05128B] to-[#2B64F5]" />
        <div className="py-5 px-[20px]">
          <div className="base-container flex justify-start flex-wrap gap-8">
            {menuBottom.map((item, index) => (
              <Link key={index} href={item.link}>
                <Text
                  weight="400"
                  color="#F3F5F8"
                  fontType="Expo_bok"
                  className="leading-[21px]"
                >
                  {item.title}
                </Text>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default memo(Footer);
